if (!customElements.get('qube-hero-video')) {
  customElements.define('qube-hero-video', class QubeHeroVideo extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
    }

    connectedCallback() {
      if (!this.video) return;

      // Optional: Pause video when scrolled out of view to save resources
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.video.play().catch(e => console.log('Video autoplay blocked or failed', e));
          } else {
            this.video.pause();
          }
        });
      }, { rootMargin: '0px 0px 50px 0px' });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  });
}
